if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(prefix) {
    return this.lastIndexOf(prefix, 0) === 0;
  };
}

angular.module("pe4h").factory("AuthInterceptor", [
  "$rootScope",
  "$location",
  "$q",
  "AuthService",
  function($rootScope, $location, $q, AuthService) {
    var authInterceptorService = {};
    var _AUTHHEADER = "Token ";

    var responseError = function(rejection) {
      if (rejection.status == 401 && !rejection.config.skipInterceptors) {

        $rootScope.$broadcast('logoutExpired');

        //Reject with request data as null so we do not trigger alerts
        rejection.data = null;
        return $q.reject(rejection);
      } else if (rejection.status == 403 && !rejection.config.skipInterceptors){
        if($location.$$path != "/recoverPassword"){
          $rootScope.$broadcast('forbidden', rejection.data);
          rejection.data = null;
          return $q.reject(rejection);
        }
      }
      return $q.reject(rejection);
    };
    //console.log(baseApiUrl);
    var request = function(config) {
      config.headers = config.headers || {};
      var token = AuthService.get();
      if (token && (config.url.startsWith(baseApiUrl))) {
        config.headers.Authorization = _AUTHHEADER + token;
      }
      return config;
    };

    authInterceptorService.responseError = responseError;
    authInterceptorService.request = request;
    return authInterceptorService;
  }
]);
